import { catchError } from "../../catchErrors";
import { SHOW_LESS, SHOW_MORE } from "../../resources";
import { generateURL, showMobileFilterButton } from "./offers";
import { ACTUAL_FILTER, CALL_GET_FILTERS } from "./settings";

$(() => {
  $(document).on("click", "#showAllLocations", () => {
    const locationsList = $("#locationsList");

    if (locationsList.hasClass("psf-provinces-filter__items-list--collapsed")) {
      locationsList.removeClass("psf-provinces-filter__items-list--collapsed");
      const hasProvince = $(".psf-provinces-filter__current-province").length > 0;
      if(hasProvince) locationsList.removeClass("psf-provinces-filter__items-list--collapsed-towns");
      $("#showAllLocations").text(SHOW_LESS);
    } else {
      const hasProvince = $(".psf-provinces-filter__current-province").length > 0;
      if(hasProvince) locationsList.addClass("psf-provinces-filter__items-list--collapsed-towns");
      locationsList.addClass("psf-provinces-filter__items-list--collapsed");
      $("#showAllLocations").text(SHOW_MORE);

      $([document.documentElement, document.body]).animate({
        scrollTop: $(".psf-ico.psf-ico--location-blue")?.offset()?.top! - 100
    }, 500);
    }
  });

  $(document).on("input", "#filterLocation", (event: any) => {
    const text: string = event.target.value;
    let items = 0;

    $("#locationsList [list-item]").each(
      (index: number, element: HTMLElement) => {
        if (
          $(element).data("value").toLowerCase().includes(text.toLowerCase())
        ) {
          $(element).removeClass("eui-d-none");
          items++;
        } else {
          $(element).addClass("eui-d-none");
        }
      }
    );

    if (items > 4) {
      $("#showAllLocations").removeClass("eui-d-none");
    } else {
      $("#showAllLocations").addClass("eui-d-none");
    }
  });

  $(document).on("click", "#locationsList [list-item][province]", (event) => {
    event.preventDefault();
    ACTUAL_FILTER.selectedTowns = [];
    ACTUAL_FILTER.selectedProvince = "";
    const target = event.currentTarget;
    const province = target.getAttribute("data-value");
    if (province) ACTUAL_FILTER.selectedProvince = province;
    if (window.innerWidth <= 767) {
      $.ajax({
        url: CALL_GET_FILTERS,
        data: { filter: ACTUAL_FILTER },
        type: "post",
      }).done((data) => {
        $("#offersFilters").replaceWith(data).show("fast");
        showMobileFilterButton();
      }).catch(catchError);
    } else generateURL();
  });

  $(document).on("click", "#locationsList [list-item][town]", (event) => {
    event.preventDefault();
    const target = event.currentTarget;
    const town = target.getAttribute("data-value");
    if (town) {
      let index = ACTUAL_FILTER.selectedTowns.indexOf(town);
      if (index != -1) {
        ACTUAL_FILTER.selectedTowns.splice(index, 1);
        target.querySelector("input")?.removeAttribute("checked");
      } else {
        ACTUAL_FILTER.selectedTowns.push(town);
        target.querySelector("input")?.setAttribute("checked", "");
      }
    }
    window.innerWidth <= 767
      ? showMobileFilterButton()
      : generateURL();
  });

  $(document).on("click", "#removeLocation", (event) => {
    event.preventDefault();
    ACTUAL_FILTER.selectedTowns = [];
    ACTUAL_FILTER.selectedProvince = "";
    if(window.innerWidth <= 767) {
      $.ajax({
        url: CALL_GET_FILTERS,
        data: { filter: ACTUAL_FILTER },
        type: "post",
      }).done(function (data) {
        $("#offersFilters").replaceWith(data).show("fast");
      }).catch(catchError);
    } else generateURL();
  });
});
